<template>
  <div v-title data-title="感恩节回馈活动 | 参与人数">
    <section class="active-bg">
      <div class="act-user">
        <div class="act-figure">
          <img :src="formset.WeChatImgUrl" class="avatar" />
          <p v-if="formset.ChoosePrizeCount>0">
            恭喜您
            <br />
            您有{{formset.ChoosePrizeCount}}次选择奖品的机会！
          </p>
          <p v-if="formset.ChoosePrizeCount<=0">
            离第{{formset.AlreadyReceivedPrizeCount+1}}次获取奖品的机会还差{{formset.NextInviteNumer}}个人
            <br />继续加油，家游
          </p>
          <a
            v-if="formset.ChoosePrizeCount>0"
            href="javascript:void(0)"
            @click="getprize(formset.ProductGuids[0])"
          >
            <img src="../../assets/img/act-1.png" />
          </a>
          <a
            v-if="formset.ChoosePrizeCount>0"
            href="javascript:void(0)"
            @click="getprize(formset.ProductGuids[1])"
          >
            <img src="../../assets/img/act-2.png" />
          </a>
        </div>
      </div>
      <div class="container">
        <div class="act-tips">
          <p class="title">获取券码方法</p>
          <p>
            a、平台会将券码通过短信发送到您的手机上，如果您没有收到短信，看b方法
            <br />b、进入壹选生活公众号，进入商城，查看我的订单就可以找到该券码，还不会，看第c
            <br />c、加周末小秘书微信或者打电话025-858921561，工作时间9:00到17:30
          </p>
        </div>
        <ul class="act-wx-list">
          <li class="title">
            <p class="act-wx-avatar">微信头像</p>
            <p class="act-wx-name">昵称 参与时间</p>
            <p>助力进度</p>
          </li>
          <li v-for="(item,$index) in formset.AssistingUsers" :key="$index">
            <div class="act-wx-avatar">
              <img :src="item.WeChatImgUrl" class="avatar" />
            </div>
            <div class="act-wx-name">
              <p>{{item.WeChatName}}</p>
              <span>{{item.AttendTime}}</span>
            </div>
            <div class="act-wx-status">已为您助力</div>
          </li>

          <li
            v-for="($index) in formset.NextInviteNumer"
            :key="$index"
            :style="formset.ChoosePrizeCount<=0?'':'display:none'"
          >
            <div class="act-wx-avatar">
              <img src="../../assets/img/deng.png" class="avatar" />
            </div>
            <div class="act-wx-name"></div>
            <div class="act-wx-status">等待助力</div>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
import { Toast } from "we-vue";
import Vue from "vue";
import thumb from "../../assets/logo.png";
import { Dialog } from "we-vue";
import wx from "weixin-js-sdk";
import { debug } from "util";

export default {
  name: "activitycompletion",
  data: function() {
    return {
      LoginType: -1,
      formset: {},
      activityGuid: ""
    };
  },
  computed: {},
  created: function() {
    var activityGuid = this.$route.query.activityGuid;
    if (activityGuid != undefined) {
      this.activityGuid = activityGuid;
    }
    this.init();
  },
  methods: {
    toHome() {
      this.$router.push("/app/home");
    },
    init: function() {
      this.$http
        .get(
          this.GLOBAL.BASE_URL + "api/tbactivityuser/getactivitycompletion",
          {
            params: {
              activityGuid: this.activityGuid
            }
          }
        )
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.formset = rep.Data;
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {}
        );
    },

    getprize: function(productGuid) {
      this.$store.commit("showLoading");
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/tborder/getprize", {
          params: {
            activityGuid: this.activityGuid,
            productGuid: productGuid
          }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              Toast.success("领取成功");
              this.init();
            } else {
              Toast.fail(rep.Message);
            }
            this.$store.commit("hideLoading");
          },
          function(d) {}
        );
    }
  }
};
</script>









// WEBPACK FOOTER //
// src/components/fissionactivity/activitycompletion.vue